import React from "react";
import Card from "./card";
import Grid from "@material-ui/core/Grid";
import {
  createMuiTheme,
  makeStyles,
  ThemeProvider,
} from "@material-ui/core/styles";
const theme = createMuiTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
    },
  },
});
theme.spacing(3);
// this.props.queue contains all the cards in an array, values in attributes
// data:
//    this.props.queue[0].attributes.background_color (Currntly will be dark_green or light_green, possibility of future colors)
//    this.props.queue[0].attributes.card_text (display text, limited to 102 characters, trim on your end (data is 255))
//    this.props.queue[0].attributes.hover_text (text on hover, limited to 114 characters, trim on your end (data is 255))
//    this.props.queue[0].attributes.link (could be null, full url)
//    this.props.queue[0].attributes.image (could be null, image object (see below))
/*    this.props.queue[0].attributes.image {
            alt: "Dummy Text"
            filemime: "image/png"
            filename: "card.png"
            filesize: "4354"
            height: "350"
            uri: "https://content.uvm.edu/shared/files/styles/1200/public/sustainability/card.png"
            width: "250"
          } */
const CardQueue = (props) => {
  const makeGrid = () => {
    if (typeof props.queue !== "undefined") {
      return props.queue.map((card, index) => (
        <Card
          front={card.attributes.card_text.slice(0, 116)}
          back={card.attributes.hover_text} //.slice(0, 147)
          bgcolor={card.attributes.background_color}
          link={card.attributes.link}
          image={card.attributes.image}
          key={index}
          xs={12}
          sm={6}
          md={4}
          lg={3}
        />
      ));
    } else return null;
  };

  console.log("CardQueue =>", props.queue);
  return (
    <div
      style={{ marginLeft: "20px", marginRight: "20px", paddingBottom: "16px" }}
    >
      <ThemeProvider theme={theme}>
        <Grid container>
          <Grid item xs={12}>
            <Grid
              container
              spacing={3}
              style={{
                maxWidth: "1200px",
                flexGrow: "1",
                boxSizing: "border-box",
              }}
            >
              {makeGrid()}
            </Grid>
          </Grid>
        </Grid>
      </ThemeProvider>
    </div>
  );
};

export default CardQueue;
